export const PRODUCTS = {
  avia: 'avia',
  poezda: 'poezda',
  hotels: 'hotels',
  bus: 'bus',
  bundles: 'bundles',
  cars: 'cars',
};

export const TYPES = {
  advertisement: 'ADVERTISEMENT',
  deal: 'DEAL',
};

export const LABEL_TYPES = {
  discount: 'discount',
};

export const MIN_DEALS_BANNER_COUNT = {
  desktop: 5,
  tablet: 4,
  mobile: 3,
};

export const DEALS_LIMIT = 7;
